import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useMemo,
} from "react";
import PropTypes from "prop-types";
import InputForm from "./InputPassObjects.view";

import { useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";

const InputPassObjectsContainer = ({
  objectsPassed,
  objectsPreSelected = [],
  onChange,
  renderField = (obj) => ` ${obj.batch}`,
  searchField = "batch",
  sortField = "batch",
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [objectsBack, setObjectsBack] = useState(null);
  const [objects, setObjects] = useState([]);
  const [objectsSelected, setObjectsSelected] = useState([]);
  const [initValues, setInitValues] = useState({});
  const [data, setData] = useState(null);
  const [filter, setFilter] = useState("");
  const isInitialized = useRef(false);

  // Inicialización solo una vez
  useEffect(() => {
    if (!isInitialized.current && objectsPassed && objectsPassed.length > 0) {
      const preSelected = objectsPreSelected || [];
      const available = objectsPassed.filter(
        (obj) => !preSelected.find((sel) => sel.uuid === obj.uuid)
      );
      setObjects(arrayOrder(available, sortField));
      setObjectsSelected(arrayOrder(preSelected, sortField));
      isInitialized.current = true;
    }
  }, [objectsPassed, objectsPreSelected, sortField]);

  // Notificar cambios solo después de la inicialización y cuando realmente cambian los seleccionados
  useEffect(() => {
    if (isInitialized.current && onChange) {
      onChange(objectsSelected);
    }
  }, [objectsSelected, onChange]);

  const handlerOnSelectObjects = async (object) => {
    const newSelected = [...objectsSelected];
    newSelected.push(object);
    const newAllowed = [...objects];
    const index = newAllowed.findIndex((obj) => obj.uuid === object.uuid);
    if (index !== -1) {
      newAllowed.splice(index, 1);
    }
    setObjectsSelected(arrayOrder(newSelected, sortField));
    setObjects(arrayOrder(newAllowed, sortField));
    setFilter("");
    setObjectsBack([]);
  };

  const handlerOnSelectAllObjects = async () => {
    const newSelected = [...objectsSelected, ...objects];
    setObjectsSelected(arrayOrder(newSelected, sortField));
    setObjects([]);
    setFilter("");
    setObjectsBack([]);
  };

  const handlerOnDeleteObject = async (object) => {
    const newAllowed = [...objects];
    newAllowed.push(object);

    const newSelected = [...objectsSelected];
    const index = newSelected.findIndex((obj) => obj.uuid === object.uuid);
    if (index !== -1) {
      newSelected.splice(index, 1);
    }
    setObjectsSelected(arrayOrder(newSelected, sortField));
    setObjects(arrayOrder(newAllowed, sortField));
  };

  const handlerOnDeleteAllObject = async () => {
    const newAllowed = [...objectsSelected, ...objects];
    setObjectsSelected([]);
    setObjects(arrayOrder(newAllowed, sortField));
  };

  const arrayOrder = (array, sortBy) => {
    return array.sort((a, b) => {
      if (a[sortBy] < b[sortBy]) return -1;
      if (a[sortBy] > b[sortBy]) return 1;
      return 0;
    });
  };

  const filterObjects = useCallback(
    (value) => {
      setFilter(value);
      if (value.length > 0) {
        const regex = new RegExp(value, "i");
        const toFilter = [...objects];
        const newObjects = toFilter.filter((obj) =>
          regex.test(obj[searchField])
        );
        setObjectsBack(newObjects);
      } else {
        setObjectsBack([]);
      }
    },
    [objects, searchField]
  );

  return (
    <InputForm
      objects={objects}
      objectsSelected={objectsSelected}
      onSelectObject={handlerOnSelectObjects}
      onDeleteObject={handlerOnDeleteObject}
      onSelectAll={handlerOnSelectAllObjects}
      onDeleteAll={handlerOnDeleteAllObject}
      filterObjects={filterObjects}
      objectsBack={objectsBack}
      filter={filter}
      renderField={renderField}
    />
  );
};

InputPassObjectsContainer.propTypes = {
  objectsPassed: PropTypes.array.isRequired,
  objectsPreSelected: PropTypes.array,
  onChange: PropTypes.func,
  renderField: PropTypes.func,
  searchField: PropTypes.string,
  sortField: PropTypes.string,
};

export default InputPassObjectsContainer;
